import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AnuncioResponse } from "../typings";
import http  from 'infra/http';

export function useDetalheAnuncio(id: string) {
  return useQuery<AnuncioResponse, AxiosError>(
    `/v1/anuncio-${id}`,
    async () => {
      const {data} = await http.get<AnuncioResponse>(`/v1/anuncio/${id}`)

      return data;
    }
  );
}
